import { Link } from "react-router-dom";

const AdminPanel = () => (
  <div className="adminPanel">
    <h1>Bienvenue sur votre espace admin.</h1>
    <p className="adminPanel-p">
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Unde earum
      incidunt praesentium animi dicta autem exercitationem nihil ipsam iusto
      enim facere temporibus id excepturi recusandae soluta adipisci suscipit
      rem, consectetur minima tempore eveniet laudantium? Sapiente esse impedit
      unde rerum! Natus error ullam eius facere corporis. Hic at officia
      temporibus dolorem.
    </p>
    <p className="adminPanel-p">
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Unde earum
      incidunt praesentium animi dicta autem exercitationem nihil ipsam iusto
      enim facere temporibus id excepturi recusandae soluta adipisci suscipit
      rem, consectetur minima tempore eveniet laudantium? Sapiente esse impedit
      unde rerum! Natus error ullam eius facere corporis. Hic at officia
      temporibus dolorem.
    </p>
    <p className="adminPanel-p">
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Unde earum
      incidunt praesentium animi dicta autem exercitationem nihil ipsam iusto
      enim facere temporibus id excepturi recusandae soluta adipisci suscipit
      rem, consectetur minima tempore eveniet laudantium? Sapiente esse impedit
      unde rerum! Natus error ullam eius facere corporis. Hic at officia
      temporibus dolorem.
    </p>
  </div>
);

export default AdminPanel;
